/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import { getApiTargetInfo } from 'core'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'

import {
  getUnitTypeInfo,
  postUnitTypeInfo,
  deleteUnitTypeInfo,
} from 'api/pgads.js'
import { Input, Button } from 'antd'
import { STORE_UNIT_TYPE_CODE } from 'core/action-names'
import CommonScreen from './CommonScreen'

const headers = [
  strCol({
    ident: 'unitCode',
    display: 'Unit Code',
    isKey: true,
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 250,
    isFiltered: true,
    isRequired: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const retrieveTask = apiTargetInfo => getUnitTypeInfo(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  postUnitTypeInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteUnitTypeInfo(apiTargetInfo)(data)

const title = 'Unit Type Management'

const UnitType = ({ saveUnitType }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  // const setData = data => {
  //   setInsertData({ ...insertData, ...data })
  // }
  // const onCancel = () => {
  //   setInsertEvent(false)
  // }

  // const onAdd = ({ hide, retrieve }) => {
  //   if (insertData.unitCode === undefined || insertData.unitCode.trim().length == 0) {
  //     message.error('Please, Insert Unit Code before Save')
  //     return
  //   }

  //   modifyTask(apiTargetInfo)([insertData]).fork(setErr, _ => {
  //     message.info('Data Saved')
  //     setInsertEvent(!hide)
  //     setInsertData({})
  //     retrieve && retrieve()
  //   })
  // }
  // useEffect(() => {
  //   setInsertData({})
  // }, [insertEvent])

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          borderSpacing: '10px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <td style={{ width: '150px' }}>Unit Code : </td>
            <td style={{ width: '300px' }}>
              <Input
                name="unitCode"
                value={insertData.unitCode}
                onChange={e =>
                  setInsertData({ ...insertData, unitCode: e.target.value })
                }
                maxLength={2}
              />
            </td>
            <td style={{ width: '300px' }} />
            <td />
          </tr>
          <tr>
            <td>Description : </td>
            <td colSpan={2}>
              <Input
                name="description"
                value={insertData.description}
                onChange={e =>
                  setInsertData({ ...insertData, description: e.target.value })
                }
              />
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
  const onRetrieveData = data => saveUnitType(data)

  // <SimpleScreen
  //   title={title}
  //   heightOffSet={200}
  //   widthOffSet={300}
  //   headers={headers}
  //   renderCriteria={props => <RetrieveCriteria {...props} />}
  //   getModifyTask={modifyTask(apiTargetInfo)}
  //   getDeleteTask={deleteTask(apiTargetInfo)}
  //   getRetrieveTask={retrieveTask(apiTargetInfo)}
  //   isEditable
  // />
  return [
    <CommonScreen
      title={title}
      header={headers}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.unitCode}
      autoRetrieve
      //      sortOptions={[{ ident: 'unitCode', display: 'Unit Code', sortOrder: 'asc' }]}
      widthOffset={500}
      insertComp={insertEvent && insertComp}
      insertCompHeight={150}
      onInsertEvent={b => setInsertEvent(b)}
      onRetrieveData={onRetrieveData}
    />,
  ]
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})
const mapDispatchToProps = dispatch => ({
  saveUnitType: data => dispatch({ type: STORE_UNIT_TYPE_CODE, payload: data }),
})

export default connect(mapStateToProps, mapDispatchToProps)(UnitType)
